import React, { useEffect, useState } from "react";
import 'react-loading-skeleton/dist/skeleton.css'
import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import GenealogyTreeContent from "../../components/Tree/genealogy-tree/GenealogyTreeContent";
import { useSelector } from "react-redux";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

const GenealogyTree = () => {
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [doubleUser, setDoubleUser] = useState("");

  const [treePlan, setTreePlan] = useState(null);
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const userDefaultPlan = getUserDefaultPlan();

  useEffect(() => {
    if (userDefaultPlan) {
      setTreePlan(userDefaultPlan);
    } else if (userPlans?.defaultPlan) {
      setTreePlan(userPlans.defaultPlan);
    }
  }, [userPlans, userDefaultPlan]);
  useEffect(() => {
    setSelectedUserId("");
  }, [treePlan]);
  return (
    <>
      {treePlan &&
        <>
          <TreeViewNavbar
            menu={"genealogyTree"}
            searchUsername={searchUsername}
            setSearchUsername={setSearchUsername}
            setSelectedUserId={setSelectedUserId}
            treePlan={treePlan}
            setTreePlan={setTreePlan}
          />
          <GenealogyTreeContent
            selectedUserId={selectedUserId}
            setSelectedUserId={setSelectedUserId}
            doubleUser={doubleUser}
            setDoubleUser={setDoubleUser}
            searchUsername={searchUsername}
            setSearchUsername={setSearchUsername}
            treePlan={treePlan}
          />
        </>
      }
    </>
  );
};

export default GenealogyTree;
